import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { ApplicationDataGridRowProps } from '@/models/Application';
import ApplicationStatusBadge from '../dashboard_components/ApplicationStatusBadge';
import { ApplicationStatus } from '@/utils/constants';
import { getStatusDescription } from '@/utils/statusUtil';
import { StatusProps } from '@/models/Status';

export const StatusColumnCell = (
  allStatuses: StatusProps[],
  localeLanguageCode: string | null,
  gridColumnOverrides: GridColDef<ApplicationDataGridRowProps> = {
    field: 'statusDescription',
    headerName: 'Status',
    minWidth: 300,
    flex: 2,
    align: 'left',
  }
): GridColDef<ApplicationDataGridRowProps> => {
  const { field, headerName, minWidth, flex, align } = gridColumnOverrides;

  return {
    field: field,
    headerName: headerName,
    minWidth: minWidth, // Adjusted from flex
    flex: flex,
    align: align,
    renderCell: (params: GridRenderCellParams<ApplicationDataGridRowProps>) => {
      const dashRow: ApplicationDataGridRowProps = params.row;
      const value = params.value as string;
      return (
        <ApplicationStatusBadge
          status={dashRow.status}
          isPendingApprovalAnnouncement={dashRow.isPendingApprovalAnnouncement}
          text={value}
        />
      );
    },
    valueGetter: (value: string, row: ApplicationDataGridRowProps) => {
      if (row.status === ApplicationStatus.Closed && row.applicationClosedReason?.code != null) {
        const reason = row.applicationClosedReason as unknown as {
          code: string;
          description?: string;
        };

        if (reason.description != null) {
          // Closed (R01 - Application created in error)
          return `${value} (${reason.code} - ${reason.description})`;
        }

        // Closed (R01) // No description
        return `${value} (${reason.code})`;
      }

      return row.isPendingApprovalAnnouncement
        ? 'Pending Approval Announcement'
        : (getStatusDescription(allStatuses, row?.status ?? null, localeLanguageCode) ?? '');
    },
  };
};

export default StatusColumnCell;
